<template lang="pug">
.wrapper(v-if="initBlock")
  //- draggable(v-model="block.blocks" v-bind="dragOptions" @change="(e) => dropBlock(e)")
  //-   transition-group(type="transition" name="flip-list")
  div(v-for="nestedBlock, idx in initBlock.blocks" :key="nestedBlock.key")
    //- .margin-top
    b-dropdown.new-block-button(v-if="initBlock.nestedAllowed && initBlock.nestedAllowed.length > 0 && nestedBlock && !nestedBlock.componentName" aria-role='list' @input="(e) => addBlock(e, idx)")
      template(#trigger='{ active }')
        b-button(type='is-white' icon-left="plus" size="is-small")
      b-dropdown-item(v-for="component in possibleComponents()" :focusable="false" aria-role='listitem' :value="component.uuid") {{component.name}}

    .nice-divider
      .reference-name(v-if="nestedBlock && !nestedBlock.componentName && (!nestedBlock.config || !nestedBlock.config.label)") {{nestedBlock.name}}
        b-button(type="is-white" size="is-small" icon-left="cog-outline" @click="modelInfos = {nestedBlock, initBlock}; showSettingsBlock = true")
        b-tag(v-if="nestedBlock.name === 'Absatz' && nestedBlock.isHidden" rounded) 🫣 nicht sichtbar
      CMSBlockGroup(:initBlock="nestedBlock" :parentKey="initBlock.key")
    //- pre {{nestedBlock}}
    component(v-if="nestedBlock && nestedBlock.componentName" :is="nestedBlock.componentName" :initBlock="nestedBlock" :parentKey="initBlock.key")

  b-dropdown.new-block-button(v-if="initBlock.nestedAllowed && initBlock.nestedAllowed.length > 0" aria-role='list' @input="(e) => addBlock(e, initBlock.blocks.length)")
    template(#trigger='{ active }')
      b-button(type='is-white' icon-left="plus" size="is-small")
    b-dropdown-item(v-for="component in possibleComponents()" :focusable="false" aria-role='listitem' :value="component.uuid") {{component.name}}
  
  b-modal(v-model="showSettingsBlock"
        has-modal-card
        :full-screen="false" 
        :can-cancel="true"
        @close="modelInfos = null")
    .modal-card(style="width: auto")  
      header.modal-card-head
        p.modal-card-title Einstellungen für {{modelInfos && modelInfos.nestedBlock.name}}
      section.modal-card-body
        b-button(icon-left="arrow-up" type="is-lightgray" @click="repositionBlock(modelInfos.initBlock.key, modelInfos.nestedBlock.key, 'up')") nach oben
        .spacer.sm.inline
        b-button(icon-left="arrow-down" type="is-lightgray" @click="repositionBlock(modelInfos.initBlock.key, modelInfos.nestedBlock.key, 'down')") nach unten
        .spacer.sm.inline
        b-button(icon-left="close" type="is-danger" @click="removeBlock(modelInfos.initBlock.key, modelInfos.nestedBlock.key)") löschen
        template(v-if="modelInfos && modelInfos.nestedBlock.name === 'Absatz'")
            br
            br
            b-field(label="Auf der Seite nicht anzeigen")
                b-switch(v-model="modelInfos.nestedBlock.isHidden" @input="updateBlock") Ja, nicht anzeigen

</template>

<script>
import { v4 as uuidv4 } from 'uuid';
import draggable from 'vuedraggable';
import CMSBlock from '@/components/cms/Block.vue';

import Text_v1 from '@/components/cms/Text_v1.vue';
import RichText_v1 from '@/components/cms/RichText_v1.vue';
import RentObject_v1 from '@/components/cms/RentObject_v1.vue';
import Image_v1 from '@/components/cms/Image_v1.vue';
import Pdf_v1 from '@/components/cms/Pdf_v1.vue';
import Cta_v1 from '@/components/cms/Cta_v1.vue';
import DateSelect_v1 from '@/components/cms/DateSelect_v1.vue';
import Url_v1 from '@/components/cms/Url_v1.vue';
import Table_v1 from '@/components/cms/Table_v1.vue';
import TagInput_v1 from '@/components/cms/TagInput_v1.vue';

export default {
  name: "CMSBlockGroup",
  props: {
    init: {
      type: Boolean,
      default: false
    },
    initBlock: {
      type: Object,
      default() {
        return null
      }
    },
    parentKey: String
  },
  data() {
    return {
      block: null,
      modelInfos: null,
      showSettingsBlock: false
    };
  },
  components: {
    draggable,
    CMSBlock,
    Text_v1,
    RichText_v1,
    RentObject_v1,
    Image_v1,
    Pdf_v1,
    Cta_v1,
    DateSelect_v1,
    Url_v1,
    TagInput_v1,
    Table_v1
  },
  computed: {
    blockModels() {
      return this.$store.state.blockModels.all;
    },
    // medias() {
    //   return this.$store.state.medias.all;
    // },
    dragOptions() {
      return {
        animation: 200,
        group: "description",
        disabled: false,
        ghostClass: "ghost"
      };
    }
  },  
  methods: {
    injectBlocks(nestedBlock) {
      if (nestedBlock.blockModel) {
        return this.blockModels.find(b => b.uuid === nestedBlock.blockModel);
      }
      return nestedBlock;
    },
    getModelFromUUID(uuid) {
      return this.blockModels.find(b => b.uuid === uuid);
    },
    possibleComponents() {
      if (!this.initBlock.nestedAllowed) return this.blockModels.filter(b => b.root);
      return this.getModelFromUUID(this.initBlock.uuid).nestedAllowed.map( n => ({ ...this.getModelFromUUID(n) }));
    },
    addBlock(e, idx) {
      const model = this.blockModels.find(b => b.uuid === e);
      if (!model) return;
      this.$root.$emit('createBlockJSON', {
        key: this.initBlock.key,
        json: JSON.parse(JSON.stringify({...model, key: uuidv4()})),
        index: idx
      });
    },
    removeBlock(parentKey, key) {
      this.$root.$emit('removeBlockJSON', {
        parentKey: parentKey,
        key: key
      });
      this.showSettingsBlock = false;
    },
    repositionBlock(parentKey, key, direction) {
      this.$root.$emit('repositionBlockJSON', {
        parentKey: parentKey,
        key: key,
        direction
      });
      this.showSettingsBlock = false;
    },
    updateBlock() {
      this.$root.$emit('justSave'); 
    },
    async dropBlock(payload, target) {
      console.log(payload, target);
    },
    async checkMove(evt, originalEvent) {
      console.log(originalEvent.type);
    },
    async clone(val) {
      console.log(val);
      return val;
    }
  },
  async mounted() {
    // if (this.blockModels.length <= 0) {
    //   await this.$store.dispatch("blockModels/findAll");
    // }
    // if (this.medias.length <= 0) {
    //   await this.$store.dispatch("medias/findAll");
    // }

    // When no component is available we need to destrcuture the blockModel
    if (this.initBlock && !this.initBlock.componentName && this.initBlock.name && !this.initBlock.blocks) {
      this.$root.$emit('initBlockJSON', {
        name: this.initBlock.name,
        parentKey: this.parentKey,
        key: uuidv4(),
        blockModel: this.blockModels.find(b => b.uuid === this.initBlock.uuid)
      });
    }

    // In case a component simply dont have any blocks we save right away as the pure existens of the component is needed only
    if (this.initBlock.blocks && this.initBlock.blocks.length === 0) {
      this.$root.$emit('justSave');   
    }
  }
}
</script>

<style lang="scss" scoped>
.flip-list-enter {
  transition: transform 0.5s;
}

.no-move {
  transition: transform 0s;
}

.ghost {
  opacity: 0.5;
  background: #c8ebfb;
}

.reference-name {
  display: flex;
  align-items: center;
  position: relative;
  // margin-bottom: 12px;
}

.name {
  margin-bottom: $sm-space;
  font-weight: 500;
  span {
    margin-left: 3px;
  }
}

.nice-divider {
  padding-left: 8px;
  // padding-right: 4px;
  border-left: 4px solid rgba($primary,0.16); 
}
.new-block-button {
  margin-top: 12px;
  margin-bottom: 12px;
}
</style>